import React, { CSSProperties, useMemo } from 'react'

import {
  ILayout_Render,
  ILayout_Cell_Props_Table,
} from '../types/layout'

const getStyles: {
  (props?: any): Record<string, CSSProperties>,
} = ({
  
} = {}) => ({
  table: {
    width: '100%',
  },
})

const TableComponent: ILayout_Render<ILayout_Cell_Props_Table> = ({
  cell,
}) => {

  const styles = getStyles()

  let data = []
  let config = {
    columns: [],
  }

  if (cell.data.table) {
    data = cell.data.table.data || []
    config = cell.data.table.config || {
      columns: [],
    }
  }

  return (
    <table style={ styles.table }>
      <thead>
        <tr>
          {
            config.columns.map((c, i) => {
              return (
                <th key={ i }>
                  { c }
                </th>
              )
            })
          }
        </tr>
      </thead>
      <tbody>
        {
          data.map((row, i) => {
            return (
              <tr key={ i }>
                {
                  row.map((cell, j) => {
                    return (
                      <td key={ j }>
                        { cell }
                      </td>
                    )
                  })
                }
              </tr>
            ) 
          })
        }
      </tbody>
    </table>
  )
}

export default TableComponent 